import React from 'react';
import Link from 'gatsby-link';
import imgCF from './jake.jpg';
import BackNav from '../components/BackNav';
import FooterRainbow from '../components/FooterRainbow';

// Breathe Images
import imgBreathe1 from "../images/breathe-1.jpeg";
import imgBreathe2 from "../images/breathe-2.jpeg";
import imgBreathe3 from "../images/breathe-3.jpeg";
import imgBreathe4 from "../images/breathe-4.png";
import imgBreathe5 from "../images/breathe-web.jpg";

import imgCF1 from '../images/crossfader/crossfader-doors.gif';

const BreatheApp = () =>
  <div>
    <div className="main work-page relative">
      <BackNav />
      <div className="row">
        <h1 className='huge-text col-sm-12'>Breathe</h1>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <p><a href="https://itunes.apple.com/us/app/breathe-daily-breathing-reminders/id976954751?ls=1&mt=8">Breathe</a> is a friendly mindfulness app that helps you stay relaxed by sending you gentle relaxation reminders - "Breathers" - throughout your day. A free app, it was conceived by my friend Ben Erez, and designed by myself, and built by Mohammed Islam. <a href="http://williamnewton.co/blog/breathe/">I wrote about our process creating Breathe here.</a> It's available now on the <a href="https://itunes.apple.com/us/app/breathe-daily-breathing-reminders/id976954751?ls=1&mt=8">App Store.</a></p>
          <p>Since I started practicing yoga, I've learned the importance of the breath. Being conscious of my breathing and using it as a tool to relax and be mindful has had a hugely positive impact on my life — so that's the purpose of Breathe, to share this with others. </p>
        </div>
      </div>

      <div className='row'>
        <div className="col-sm-4">
          <img className="img-responsive" src={imgBreathe1} />
        </div>
        <div className="col-sm-4">
          <img className="img-responsive" src={imgBreathe2} />
        </div>
        <div className="col-sm-4">
          <img className="img-responsive" src={imgBreathe3} />
        </div>
      </div>

        <p className="lead"></p>

      <div className='row'>
        <div className="col-sm-12">
          <img className="img-responsive" src={imgBreathe4} />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <img className="img-responsive shadow" src={imgBreathe5} />
        </div>
      </div>

    </div>

    <FooterRainbow />

  </div>

export default BreatheApp



// WEBPACK FOOTER //
// ./src/pages/breatheapp.js